// ── 에픽던전 데이터 ──────────────────────────────────
// 세라자르 주화 가격 변경 시 SERAJAR_PRICE만 수정하세요.
// 2026.06 업데이트 기준

export const SERAJAR_PRICE = 40000000; // 개당 4,000만 메소

export const EPIC_DUNGEONS = [
  {
    key: "highmountain",
    name: "하이마운틴",
    baseReward: {
      sol: 1,         // 솔에르다 개수
      darkGun: 0,     // 짙은 솔에르다의 기운
      solFragment: 15, // 솔에르다 조각 (교환불가)
    },
    expBonus: [
      { level: 0, coin: 0,  mp: 0 },
      { level: 1, coin: 4,  mp: 7500 },
      { level: 2, coin: 8,  mp: 30000 },
    ],
    solBonus: [
      { level: 0, coin: 0, sol: 0,  darkGun: 0,  mp: 0 },
      { level: 1, coin: 4, sol: 4,  darkGun: 0,  mp: 7500 },
      { level: 2, coin: 8, sol: 8,  darkGun: 0,  mp: 30000 },
    ],
  },
  {
    key: "angler",
    name: "앵글러 컴퍼니",
    baseReward: {
      sol: 1,
      darkGun: 1,     // 짙은 솔에르다의 기운 1개
      solFragment: 15,
    },
    expBonus: [
      { level: 0, coin: 0,  mp: 0 },
      { level: 1, coin: 4,  mp: 10000 },
      { level: 2, coin: 8,  mp: 40000 },
    ],
    solBonus: [
      { level: 0, coin: 0, sol: 0,  darkGun: 0,  mp: 0 },
      { level: 1, coin: 4, sol: 4,  darkGun: 4,  mp: 10000 },
      { level: 2, coin: 8, sol: 8,  darkGun: 8,  mp: 40000 },
    ],
  },
  {
    key: "nightmare",
    name: "악몽선경",
    baseReward: {
      sol: 2,
      darkGun: 0,
      solFragment: 15,
    },
    expBonus: [
      { level: 0, coin: 0,  mp: 0 },
      { level: 1, coin: 4,  mp: 12500 },
      { level: 2, coin: 8,  mp: 50000 },
    ],
    solBonus: [
      { level: 0, coin: 0, sol: 0,  darkGun: 0,  mp: 0 },
      { level: 1, coin: 4, sol: 8,  darkGun: 0,  mp: 12500 },
      { level: 2, coin: 8, sol: 16, darkGun: 0,  mp: 50000 },
    ],
  },
];

/**
 * 에픽던전 보상 계산
 * @param {string} dungeonKey - 'highmountain' | 'angler' | 'nightmare'
 * @param {number} expLevel   - 0 | 1 | 2
 * @param {number} solLevel   - 0 | 1 | 2
 * @returns {{ coin, sol, darkGun, solFragment, mp, mesoIncome, totalGunEquiv }}
 *   totalGunEquiv: 솔에르다 기운 환산 총합 (솔1=기운1000, 짙은기운1=기운500)
 */
export function calcEpicReward(dungeonKey, expLevel, solLevel) {
  const dungeon = EPIC_DUNGEONS.find(d => d.key === dungeonKey);
  if (!dungeon) return null;

  const exp = dungeon.expBonus[expLevel] || dungeon.expBonus[0];
  const sol = dungeon.solBonus[solLevel] || dungeon.solBonus[0];

  const totalCoin      = exp.coin + sol.coin;
  const totalSol       = dungeon.baseReward.sol + sol.sol;
  const totalDarkGun   = dungeon.baseReward.darkGun + sol.darkGun;
  const totalFragment  = dungeon.baseReward.solFragment;
  const totalMp        = exp.mp + sol.mp;
  const mesoIncome     = totalCoin * SERAJAR_PRICE;

  // 솔에르다 기운 환산 총합 (화면 표기용)
  // 솔에르다 1개 = 기운 1,000개, 짙은 기운 1개 = 기운 500개
  const totalGunEquiv  = totalSol * 1000 + totalDarkGun * 500;
  const solDisplay     = Math.floor(totalGunEquiv / 1000);
  const gunRemainder   = totalGunEquiv % 1000;

  return {
    coin: totalCoin,
    sol: totalSol,
    darkGun: totalDarkGun,
    solFragment: totalFragment,
    mp: totalMp,
    mesoIncome,
    totalGunEquiv,
    solDisplay,     // 화면 표기: X / Y 에서 X
    gunRemainder,   // 화면 표기: X / Y 에서 Y
  };
}
